import React, { useContext, useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import Title from '../Title/Title';
import Subtitle from '../Title/Subtitle';
import Menu from '../Menu/Menu';
import PortfolioContext from '../../context/context';

const OurValues = () => {
  const { ourValues } = useContext(PortfolioContext);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="ourValues">
      <Container>
        <Row className="ourValues-wrapper">
          <Title title="Nos valeurs" />
          {ourValues.map((paragraph, key) => (
            <Fade
              bottom={isMobile}
              right={isDesktop}
              delay={500}
              duration={1000}
              distance="50px"
              key={key}
            >
              <div className="ourValues-wrapper__info">
                {paragraph.title && <Subtitle title={paragraph.title} />}
                {paragraph.type === 'quote' ? (
                  <p className="ourValues-wrapper__info-cite">
                    <cite>{paragraph.content}</cite>
                  </p>
                ) : (
                  <p className="ourValues-wrapper__info-text"> {paragraph.content}</p>
                )}
              </div>
            </Fade>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default OurValues;
